import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import api, { inr } from "@/lib/api";

const icon = new L.Icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41], iconAnchor: [12, 41],
});

export default function MapPage() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/properties", { params: { limit: 200 } }).then(({ data }) => setItems(data));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-10">
      <div className="text-xs uppercase tracking-[0.25em] text-[#C85A32]">Explore map</div>
      <h1 className="font-display text-4xl md:text-5xl mt-2">Rentals across India</h1>
      <div className="text-sm text-[#5C6B7A] mt-2">{items.length} properties shown</div>

      <div className="mt-6 h-[70vh] rounded-lg overflow-hidden border border-[#1A1F2C]/10" data-testid="map-container">
        <MapContainer center={[22.5, 79]} zoom={5} style={{ height: "100%", width: "100%" }}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; OpenStreetMap' />
          {items.map((p) => (
            <Marker key={p.id} position={[p.latitude, p.longitude]} icon={icon}>
              <Popup>
                <div className="w-48">
                  <img src={p.photos?.[0]} alt="" className="w-full h-24 object-cover rounded mb-2" />
                  <div className="font-semibold text-sm">{p.title}</div>
                  <div className="text-xs text-gray-500">{p.locality} • {p.bhk}BHK</div>
                  <div className="text-[#C85A32] font-semibold text-sm mt-1">{inr(p.rent)}/mo</div>
                  <Link to={`/property/${p.id}`} className="text-[#2B3A67] text-xs underline mt-1 inline-block">View details</Link>
                </div>
              </Popup>
            </Marker>
          ))}
        </MapContainer>
      </div>
    </div>
  );
}
